var map = {
	"./clipboard.svg": "9e87",
	"./full.svg": "4f8d",
	"./gift.svg": "6953",
	"./mail.svg": "4f1b",
	"./pen-tool.svg": "75f5",
	"./phone.svg": "1f9a",
	"./symbol.svg": "aba7",
	"./trending-up.svg": "3306"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";